var _mask, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgeRestrictedinline = function SvgAgeRestrictedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ageRestricted_inline_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.999,
    height: 11.789,
    x: 2.001,
    y: 3.797,
    rx: 0.85
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.999,
    height: 11.789,
    x: 2.001,
    y: 3.797,
    stroke: "#21201F",
    strokeWidth: 2,
    mask: "url(#ageRestricted_inline_svg__a)",
    rx: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "round",
    d: "M11.138 8.102h4.479M11.138 10.633h4.479"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.969 12.575v-.562a1.123 1.123 0 0 0-1.123-1.122H5.6a1.123 1.123 0 0 0-1.122 1.122v.562M6.722 8.886a1.123 1.123 0 1 0 0-2.245 1.123 1.123 0 0 0 0 2.245"
  })));
};
export default SvgAgeRestrictedinline;